module.exports = __webpack_public_path__ + "img/149-770915.png";